export const INIT_ACTION_TYPE = '@@INIT' as const;
